var map = {
	"./2CAD.svg": 1022,
	"./2JPY.svg": 1023,
	"./2OMB.png": 1024,
	"./2SGD.png": 1025,
	"./2SHARES.png": 1026,
	"./4EUR.png": 1027,
	"./AAVE.svg": 1028,
	"./AAVEe.svg": 1029,
	"./ACRE.png": 1030,
	"./ADA.svg": 1031,
	"./ADX.svg": 1032,
	"./ALI.svg": 1033,
	"./ALPACA.png": 1034,
	"./ALPHA.png": 1035,
	"./AMPL.png": 1036,
	"./ANN.png": 1037,
	"./ANY.png": 1038,
	"./AOT.png": 1039,
	"./APE.png": 1040,
	"./ARBITRUM.svg": 1041,
	"./ATLAS.png": 1042,
	"./ATOM.png": 1043,
	"./AURO.png": 1044,
	"./AURORA.svg": 1045,
	"./AVALANCHE.svg": 1046,
	"./AVAX.png": 1047,
	"./AVAX.svg": 1048,
	"./AVAXL.svg": 1049,
	"./AXS.png": 1050,
	"./Andromeda.svg": 1051,
	"./BABY.svg": 1052,
	"./BABYCAKE.svg": 1053,
	"./BAKE.png": 1054,
	"./BALL.png": 1055,
	"./BANANA.svg": 1056,
	"./BASED.svg": 1057,
	"./BCH.svg": 1058,
	"./BCT.png": 1059,
	"./BDO.png": 1060,
	"./BDP.png": 1061,
	"./BEAR.png": 1062,
	"./BEETS.png": 1063,
	"./BETA.svg": 1064,
	"./BETH.png": 1065,
	"./BETU.png": 1066,
	"./BHC.png": 1067,
	"./BICO.png": 1068,
	"./BIFI.png": 1069,
	"./BISON.png": 1070,
	"./BLZZ.svg": 1071,
	"./BMON.svg": 1072,
	"./BNB.png": 1073,
	"./BNBbsc.png": 1074,
	"./BOMB.png": 1075,
	"./BONE.png": 1076,
	"./BONEswap.png": 1077,
	"./BOO.png": 1078,
	"./BOOK.png": 1079,
	"./BORING.png": 1080,
	"./BP.png": 1081,
	"./BPT.png": 1082,
	"./BREW.png": 1083,
	"./BRIBE.png": 1084,
	"./BRUSH.png": 1085,
	"./BSC.svg": 1086,
	"./BSCDEFI.svg": 1087,
	"./BSCPAD.png": 1088,
	"./BSHARE.svg": 1089,
	"./BSTN.svg": 1090,
	"./BSW.svg": 1091,
	"./BTC.svg": 1092,
	"./BTCB.svg": 1093,
	"./BTD.png": 1094,
	"./BTS.png": 1095,
	"./BTT.png": 1096,
	"./BUNNY.png": 1097,
	"./BURGER.png": 1098,
	"./BUSD.svg": 1099,
	"./BUSDe.svg": 1100,
	"./BUSM.png": 1101,
	"./BYTE.png": 1102,
	"./CAKE.svg": 1103,
	"./CAPS.svg": 1104,
	"./CARROT.png": 1105,
	"./CCAR.png": 1106,
	"./CEEK.png": 1107,
	"./CEL.png": 1108,
	"./CELO.svg": 1109,
	"./CHARGE.png": 1110,
	"./CHARM.svg": 1111,
	"./CHESS.svg": 1112,
	"./CLAM.png": 1113,
	"./CLY.png": 1114,
	"./COOK.png": 1115,
	"./CRA.png": 1116,
	"./CRAFT.png": 1117,
	"./CRE8R.png": 1118,
	"./CREAM.svg": 1119,
	"./CRO.svg": 1120,
	"./CRONA.svg": 1121,
	"./CRONOS.svg": 1122,
	"./CRUSH.svg": 1123,
	"./CRV.png": 1124,
	"./CRYSTL.png": 1125,
	"./CTK.png": 1126,
	"./CYT.png": 1127,
	"./CZF.png": 1128,
	"./DAI.png": 1129,
	"./DAI.svg": 1130,
	"./DAIe.png": 1131,
	"./DAR.svg": 1132,
	"./DARK.svg": 1133,
	"./DBY.png": 1134,
	"./DCAU.png": 1135,
	"./DEG.png": 1136,
	"./DEI.png": 1137,
	"./DELIRIUM.png": 1138,
	"./DEP.png": 1139,
	"./DEUS.png": 1140,
	"./DFYN.png": 1141,
	"./DG.png": 1142,
	"./DIBS.png": 1143,
	"./DINO.png": 1144,
	"./DIS.svg": 1145,
	"./DKT.png": 1146,
	"./DOGE.svg": 1147,
	"./DOLA.png": 1148,
	"./DOMI.png": 1149,
	"./DOT.png": 1150,
	"./DPI.png": 1151,
	"./DPT.png": 1152,
	"./DRUGS.png": 1153,
	"./DSHARE.png": 1154,
	"./DUET.svg": 1155,
	"./DVI.svg": 1156,
	"./ECD.png": 1157,
	"./EGG.png": 1158,
	"./ELK.png": 1159,
	"./ELON.png": 1160,
	"./EMERALD.png": 1161,
	"./EMP.png": 1162,
	"./EPS.png": 1163,
	"./ERA.svg": 1164,
	"./ERTHA.png": 1165,
	"./ESHARE.png": 1166,
	"./EST.png": 1167,
	"./ETERNAL.png": 1168,
	"./ETH.svg": 1169,
	"./ETH2x.png": 1170,
	"./EURt.png": 1171,
	"./EXP.svg": 1172,
	"./EZ.png": 1173,
	"./FANTOM.svg": 1174,
	"./FET.png": 1175,
	"./FFF.png": 1176,
	"./FIEF.png": 1177,
	"./FIL.svg": 1178,
	"./FINN.png": 1179,
	"./FIRE.png": 1180,
	"./FISH.svg": 1181,
	"./FITFI.png": 1182,
	"./FLARE.png": 1183,
	"./FLX.png": 1184,
	"./FLY.png": 1185,
	"./FODL.png": 1186,
	"./FONT.png": 1187,
	"./FOO.png": 1188,
	"./FORM.svg": 1189,
	"./FOX.png": 1190,
	"./FRAX.svg": 1191,
	"./FRM.png": 1192,
	"./FROYO.png": 1193,
	"./FRUIT.png": 1194,
	"./FS.png": 1195,
	"./FTM.png": 1196,
	"./FTML.svg": 1197,
	"./FUSE Network.svg": 1198,
	"./FUSE.svg": 1199,
	"./FXS.png": 1200,
	"./G.png": 1201,
	"./GAL.png": 1202,
	"./GEIST.svg": 1203,
	"./GEL.png": 1204,
	"./GENESIS.png": 1205,
	"./GHST.png": 1206,
	"./GIDDY.png": 1207,
	"./GLINT.png": 1208,
	"./GLMR.png": 1209,
	"./GM.png": 1210,
	"./GMT.svg": 1211,
	"./GMX.png": 1212,
	"./GNS.png": 1213,
	"./GNT.png": 1214,
	"./GOLDCOIN.svg": 1215,
	"./GRAPE.png": 1216,
	"./GUARD.svg": 1217,
	"./HAI.png": 1218,
	"./HARD.png": 1219,
	"./HARMONY.svg": 1220,
	"./HAY.svg": 1221,
	"./HBAR.png": 1222,
	"./HBTC.png": 1223,
	"./HEC.png": 1224,
	"./HECO.svg": 1225,
	"./HERO.png": 1226,
	"./HIGH.png": 1227,
	"./HND.png": 1228,
	"./HONEY.png": 1229,
	"./HONOR.png": 1230,
	"./HOTCROSS.svg": 1231,
	"./HPS.png": 1232,
	"./HT.png": 1233,
	"./HTB.svg": 1234,
	"./HUSD.png": 1235,
	"./ICA.svg": 1236,
	"./ICE.png": 1237,
	"./IDIA.svg": 1238,
	"./IF.svg": 1239,
	"./IME.png": 1240,
	"./INCH.png": 1241,
	"./INJ.png": 1242,
	"./INSUR.png": 1243,
	"./INV.png": 1244,
	"./IRON.png": 1245,
	"./IXT.png": 1246,
	"./JETS.png": 1247,
	"./JEWEL.png": 1248,
	"./JOE.png": 1249,
	"./JPYC.png": 1250,
	"./JRT.png": 1251,
	"./JULD.png": 1252,
	"./JUST.png": 1253,
	"./KAE.png": 1254,
	"./KART.png": 1255,
	"./KEBAB.png": 1256,
	"./KEK.png": 1257,
	"./KIRO.png": 1258,
	"./KLIMA.png": 1259,
	"./KLO.png": 1260,
	"./KRW.png": 1261,
	"./LAC.svg": 1262,
	"./LAMBDA.svg": 1263,
	"./LAND.svg": 1264,
	"./LAZIO.png": 1265,
	"./LCD.png": 1266,
	"./LINEAR.svg": 1267,
	"./LINK.png": 1268,
	"./LINKe.png": 1269,
	"./LIQ.png": 1270,
	"./LITHIUM.svg": 1271,
	"./LONG.png": 1272,
	"./LOOT.png": 1273,
	"./LOST.png": 1274,
	"./LTC.svg": 1275,
	"./LUNA.png": 1276,
	"./MAGIC.png": 1277,
	"./MAI.png": 1278,
	"./MAI_Rose.png": 1279,
	"./MANA.png": 1280,
	"./MARSH.png": 1281,
	"./MASK.svg": 1282,
	"./MATIC.svg": 1283,
	"./MCB.png": 1284,
	"./MCRN.svg": 1285,
	"./MDX.png": 1286,
	"./MEAD.png": 1287,
	"./MECHA.png": 1288,
	"./MELT.png": 1289,
	"./MERL.svg": 1290,
	"./METAHERO.svg": 1291,
	"./METIS.svg": 1292,
	"./MILK.png": 1293,
	"./MIM.png": 1294,
	"./MOBI.svg": 1295,
	"./MONEY.png": 1296,
	"./MOON.png": 1297,
	"./MOONBEAM.svg": 1298,
	"./MOONRIVER.svg": 1299,
	"./MORE.png": 1300,
	"./MOVR.png": 1301,
	"./MSC.png": 1302,
	"./MSS.png": 1303,
	"./MST.png": 1304,
	"./MULTI.png": 1305,
	"./MUST.png": 1306,
	"./MaticX.svg": 1307,
	"./NABOX.png": 1308,
	"./NAOS.png": 1309,
	"./NCASH.png": 1310,
	"./NEAR.svg": 1311,
	"./NETT.png": 1312,
	"./NEXO.png": 1313,
	"./NFT.png": 1314,
	"./NFTY.png": 1315,
	"./NUGGET.svg": 1316,
	"./NUTS.png": 1317,
	"./NYA.png": 1318,
	"./NYAC.png": 1319,
	"./NYAS.png": 1320,
	"./O3.png": 1321,
	"./OASIS.svg": 1322,
	"./OCP.png": 1323,
	"./ONE.svg": 1324,
	"./ONG.svg": 1325,
	"./ONT.png": 1326,
	"./OOE.svg": 1327,
	"./ORBS.svg": 1328,
	"./ORKAN.png": 1329,
	"./OXD.png": 1330,
	"./PACOCA.svg": 1331,
	"./PAE.svg": 1332,
	"./PAE_AVAX.svg": 1333,
	"./PAUTO.png": 1334,
	"./PBNB.png": 1335,
	"./PEAR.svg": 1336,
	"./PEFI.png": 1337,
	"./PERA.png": 1338,
	"./PETS.png": 1339,
	"./PEX.png": 1340,
	"./PHA.png": 1341,
	"./PILLS.png": 1342,
	"./PMP.svg": 1343,
	"./PNG.png": 1344,
	"./POLYGON.svg": 1345,
	"./PORTO.png": 1346,
	"./POTS.png": 1347,
	"./PSP.png": 1348,
	"./PTP.png": 1349,
	"./PUP.png": 1350,
	"./PolyDoge.png": 1351,
	"./QBT.svg": 1352,
	"./QI.png": 1353,
	"./QUICK.png": 1354,
	"./QUIDD.png": 1355,
	"./RABBIT.svg": 1356,
	"./RACA.svg": 1357,
	"./RAMP.png": 1358,
	"./RELAY.png": 1359,
	"./REVV.svg": 1360,
	"./RIB.png": 1361,
	"./ROME.png": 1362,
	"./ROSE.png": 1363,
	"./ROUTE.png": 1364,
	"./RPG.png": 1365,
	"./SAGE.png": 1366,
	"./SAND.png": 1367,
	"./SANTOS.png": 1368,
	"./SBDO.png": 1369,
	"./SCREAM.png": 1370,
	"./SFP.png": 1371,
	"./SFUND.png": 1372,
	"./SHADE.png": 1373,
	"./SHIB.png": 1374,
	"./SHIBX.png": 1375,
	"./SHRAP.png": 1376,
	"./SING.png": 1377,
	"./SISTA.svg": 1378,
	"./SKILL.svg": 1379,
	"./SKY.svg": 1380,
	"./SMART.png": 1381,
	"./SNX.png": 1382,
	"./SOAK.png": 1383,
	"./SOL.png": 1384,
	"./SOLACE.png": 1385,
	"./SOLAR.png": 1386,
	"./SOLID.svg": 1387,
	"./SPADE.png": 1388,
	"./SPELL.png": 1389,
	"./SPIRIT.png": 1390,
	"./SPS.svg": 1391,
	"./STARS.svg": 1392,
	"./START.png": 1393,
	"./STATIC.png": 1394,
	"./STEAK.png": 1395,
	"./STEEL.png": 1396,
	"./STELLA.png": 1397,
	"./STNEAR.png": 1398,
	"./SUMMIT.png": 1399,
	"./SUSHI.png": 1400,
	"./SUSHIe.png": 1401,
	"./SWAMP.svg": 1402,
	"./SX.png": 1403,
	"./SXP.svg": 1404,
	"./SYN.svg": 1405,
	"./TAPE.svg": 1406,
	"./TEL.png": 1407,
	"./TENFI.png": 1408,
	"./TETHYS.svg": 1409,
	"./TETU.svg": 1410,
	"./THG.png": 1411,
	"./TIME.png": 1412,
	"./TITAN.svg": 1413,
	"./TLOS.svg": 1414,
	"./TOMB.png": 1415,
	"./TONIC.svg": 1416,
	"./TOR.svg": 1417,
	"./TREEB.png": 1418,
	"./TRI.svg": 1419,
	"./TRX.png": 1420,
	"./TSHARE.svg": 1421,
	"./TUS.png": 1422,
	"./TUSD.png": 1423,
	"./TYPH.png": 1424,
	"./UFT.png": 1425,
	"./UNI.png": 1426,
	"./UNIe.png": 1427,
	"./USDB.png": 1428,
	"./USDC.svg": 1429,
	"./USDCe.svg": 1430,
	"./USDCm.svg": 1431,
	"./USDCs.svg": 1432,
	"./USDD.png": 1433,
	"./USDL.svg": 1434,
	"./USDO.png": 1435,
	"./USDT.svg": 1436,
	"./USDTe.svg": 1437,
	"./UST.png": 1438,
	"./UST_Rose.png": 1439,
	"./USTaxl.png": 1440,
	"./USTw.png": 1441,
	"./VALAS.svg": 1442,
	"./VERSA.svg": 1443,
	"./VOLT.png": 1444,
	"./VTX.png": 1445,
	"./VVS.svg": 1446,
	"./WAN.svg": 1447,
	"./WATCH.png": 1448,
	"./WAULTx.svg": 1449,
	"./WBNB.svg": 1450,
	"./WBTC.svg": 1451,
	"./WBTCe.svg": 1452,
	"./WBTCeth.svg": 1453,
	"./WCRO.svg": 1454,
	"./WETH.svg": 1455,
	"./WETHe.svg": 1456,
	"./WEX.svg": 1457,
	"./WEXpoly.png": 1458,
	"./WIGO.svg": 1459,
	"./WIN.png": 1460,
	"./WINE.png": 1461,
	"./WMATIC.svg": 1462,
	"./WMATIC_DFYN.svg": 1463,
	"./WMOVR_SUSHI.png": 1464,
	"./WOO.svg": 1465,
	"./WOOFY.png": 1466,
	"./WOOP.png": 1467,
	"./WSG.svg": 1468,
	"./WSTA.png": 1469,
	"./WUSD.svg": 1470,
	"./XAVA.png": 1471,
	"./XCV.svg": 1472,
	"./XRP.svg": 1473,
	"./XTZ.png": 1474,
	"./XVS.png": 1475,
	"./XWG.png": 1476,
	"./YAMP.svg": 1477,
	"./YEL.svg": 1478,
	"./YELD.png": 1479,
	"./YETI.png": 1480,
	"./YFI.png": 1481,
	"./YFIe.png": 1482,
	"./YGG.png": 1483,
	"./YOSHI.png": 1484,
	"./YUSD.png": 1485,
	"./YUZU.png": 1486,
	"./ZBTC.svg": 1487,
	"./ZETH.svg": 1488,
	"./ZOO.png": 1489,
	"./aBNBc.png": 1490,
	"./aQI.png": 1491,
	"./aROME.png": 1492,
	"./aUSDO.svg": 1493,
	"./aWOOL.png": 1494,
	"./agEUR.png": 1495,
	"./anyMTLX.png": 1496,
	"./asUSDC.png": 1497,
	"./axlATOM.png": 1498,
	"./bQI.png": 1499,
	"./bZoo.png": 1500,
	"./beFTM.svg": 1501,
	"./beJOE.png": 1502,
	"./beQI.png": 1503,
	"./binSPIRIT.svg": 1504,
	"./bscBUSD.svg": 1505,
	"./cEUR.png": 1506,
	"./cUSD.png": 1507,
	"./cakeHARD.png": 1508,
	"./cakeROOBEE.png": 1509,
	"./cakeSTAX.png": 1510,
	"./cakeTWT.png": 1511,
	"./cakebROOBEE.png": 1512,
	"./ceUSDC.svg": 1513,
	"./cxADA.png": 1514,
	"./cxDOGE.png": 1515,
	"./cxETH.png": 1516,
	"./fUSD.png": 1517,
	"./fUSDT.png": 1518,
	"./fWINGS.svg": 1519,
	"./gOHM.png": 1520,
	"./ibBTC.svg": 1521,
	"./ironICE.svg": 1522,
	"./jCHF.png": 1523,
	"./jEUR.png": 1524,
	"./jGBP.png": 1525,
	"./jJPY.png": 1526,
	"./mUSDC.svg": 1527,
	"./mUSDT.svg": 1528,
	"./miMatic.png": 1529,
	"./newQUICK.svg": 1530,
	"./pAVAX.svg": 1531,
	"./pBNB.svg": 1532,
	"./pBREW.png": 1533,
	"./pFTM.svg": 1534,
	"./pOPEN.png": 1535,
	"./pWINGS.png": 1536,
	"./polyBUNNY.png": 1537,
	"./polyWISE.png": 1538,
	"./rUSD.svg": 1539,
	"./renBTC.png": 1540,
	"./renBTC.svg": 1541,
	"./renDGB.svg": 1542,
	"./renDOGE.png": 1543,
	"./sALPACA.svg": 1544,
	"./sAVAX.png": 1545,
	"./sFTMx.png": 1546,
	"./sSPELL.png": 1547,
	"./stKSM.png": 1548,
	"./stMATIC.png": 1549,
	"./wMEMO.png": 1550,
	"./wsHEC.png": 1551,
	"./wsSPA.png": 1552,
	"./xBOO.png": 1553,
	"./xMARK.png": 1554,
	"./xSCREAM.png": 1555,
	"./xTRI.svg": 1556,
	"./xVOLT.svg": 1557,
	"./xYELD.svg": 1558,
	"./xcDOT.png": 1559,
	"./xcKSM.png": 1560,
	"./xcRMRK.png": 1561
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1021;